import { render, staticRenderFns } from "./AdvisorySchoolsData.vue?vue&type=template&id=5e4fa235"
import script from "./AdvisorySchoolsData.vue?vue&type=script&lang=js"
export * from "./AdvisorySchoolsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports